import { useTranslation } from "react-i18next";

import { Badge, type BadgeProps } from "@sol/uikit/data-display/Badge/Badge";
const STATUS_LABELS: Record<string, { name: string; color: BadgeProps["color"] }> = {
    invited: {
        name: "admin.users.input.selectStatus.invited",
        color: "blue",
    },
    inactive: {
        name: "admin.users.input.selectStatus.inactive",
        color: "red",
    },
    active: {
        name: "admin.users.input.selectStatus.active",
        color: "green",
    },
};

type Props = {
    status: keyof typeof STATUS_LABELS;
} & Omit<BadgeProps, "status">;

export const UserStatusLabel = ({ status, ...rest }: Props) => {
    const [t] = useTranslation();
    const statusLabel = STATUS_LABELS[status] ?? { name: status, color: "default" };
    return <Badge color={statusLabel.color} text={t(statusLabel.name)} {...rest} />;
};
